import { render, staticRenderFns } from "./PerformanceComparison.vue?vue&type=template&id=66aa5d51"
import script from "./PerformanceComparison.vue?vue&type=script&lang=js"
export * from "./PerformanceComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports